// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606190616/js/" + chunkId + "." + {"44":"a8f086e2","225":"52e003a2","481":"bc9fa6c6","486":"4888a6d8","770":"60e4b534"}[chunkId] + ".0.8249823902989226.chunk.js";
};